var _excluded = ["userStore"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { inject, observer } from 'mobx-react';
export var VisibleOnlyAdministrator = function VisibleOnlyAdministrator(DecoratedComponent) {
  return function (options) {
    var Wrapper = inject('userStore')(observer(function (_ref) {
      var userStore = _ref.userStore,
          props = _objectWithoutPropertiesLoose(_ref, _excluded);

      return userStore.state.authenticating || !userStore.user.admin ? null : /*#__PURE__*/React.createElement(DecoratedComponent, props);
    }));
    return /*#__PURE__*/React.createElement(Wrapper, options);
  };
};